export default "__VITE_ASSET__DhLl8yU2__"